<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" class="ma-0 pa-0">
        <v-toolbar color="grey lighten-3" elevation="0" class="mb-2">
          <v-combobox v-model="selectedPark" :items="parks" label="Parco binari" title="Parco binari" style="max-width: 200px" class="mr-3" item-text="codice" hide-details />

          <v-text-field
            v-model="wagonSearchParam"
            append-icon="mdi-magnify"
            label="Carro (per targa)"
            title="Carro (per targa)"
            style="max-width: 300px"
            clearable
            hide-details
            class="mr-3"
          />
          <v-text-field
            v-model="utiSearchParam"
            append-icon="mdi-magnify"
            label="UTI (per codice, carrier-out, service-out)"
            title="UTI (per codice, carrier-out, service-out)"
            clearable
            style="max-width: 300px"
            hide-details
            class="mr-6"
          />

          <v-spacer />

          <v-switch v-model="shipFilterEnabled" inset hide-details @change="toggleShipFilter" class="color-switch ma-0 pa-0"></v-switch>

          <div style="width: 410px" class="d-flex flex-row align-center" v-if="!shipFilterEnabled">
            <v-btn small fab color="amber lighten-3" elevation="1" @click="selectDeselectAllFeatures" title="Seleziona/deseleziona tutte" class="mr-2">
              <v-icon color="amber darken-3">mdi-layers-outline</v-icon>
            </v-btn>
            <v-autocomplete
              v-model="selectedFeatures"
              :items="features"
              label="Caratteristiche"
              title="Caratteristiche"
              item-text="label"
              item-value="codice"
              hide-details
              class="mr-3"
              multiple
              clearable
              style="max-width: 280px"
              color="amber lighten-3"
              item-color="amber darken-3"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index === 0 || index === 1" color="white" text-color="black">
                  {{ item.label }}
                </v-chip>
                <span v-if="selectedFeatures.length > 2 && index === 2" class="grey--text text-caption"> (+{{ selectedFeatures.length - 2 }}) </span>
              </template>
            </v-autocomplete>

            <v-btn medium @click="onClickYardShow" :color="yardShowing ? 'warning' : 'white'" :title="yardActivationBtnText">
              <v-icon class="mr-1" :color="yardShowing ? 'white' : 'black'">mdi-texture-box</v-icon> YARD
            </v-btn>
          </div>

          <div style="width: 410px" class="d-flex flex-row align-center" v-else>
            <v-btn small fab color="blue lighten-4" elevation="1" @click="selectDeselectAllShips" title="Seleziona/deseleziona tutte" class="mr-2">
              <v-icon color="blue darken-1">mdi-ferry</v-icon>
            </v-btn>
            <v-autocomplete
              v-model="selectedShips"
              :items="filteredAvailableShipsByPark"
              label="Navi"
              title="Seleziona navi"
              item-text="label"
              item-value="carrierOutVoy"
              hide-details
              class="mr-3"
              multiple
              clearable
            >
              <template v-slot:selection="{ item, index }">
                <v-chip small v-if="index === 0 || index === 1" :color="item.color">
                  {{ item.carrierOutVoy }}
                </v-chip>
                <span v-if="selectedShips.length > 2 && index === 2" class="grey--text text-caption"> (+{{ selectedShips.length - 2 }}) </span>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>
                    <v-icon small left :color="item.color">mdi-circle</v-icon>
                    {{ item.carrierOutVoy }} - {{ item.callId }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>

    <!-- <v-btn @click="calc">CALC</v-btn> -->

    <v-row align="start">
      <v-col cols="12" v-if="selectedPark" ref="railParkCntrRef" id="railParkCntr" class="rail-park-cntr ma-0 pa-0" @wheel="handleWheel">
        <v-card      
          class="mx-0 px-0 mt-0 pt-0 pb-1"
          elevation="0"
          :style="{
            transform: `scale(${scaleFactor})`,
            transformOrigin: '0 0',
          }"
        >
          <v-card-text class="mx-0 px-0 mt-0 pt-0 pb-1">
            <svg v-if="lineVisible && measureEnabled" :style="svgStyle">
              <line :x1="lineLeft" y1="0" :x2="lineLeft" y2="100%" stroke="#FF8F00" stroke-width="2" />
            </svg>

            <v-container fluid class="mt-0 pt-0">
              <v-row class="rail-row mt-0 pt-0" no-gutters>
                <LengthMarker :parkPosition="selectedPark.posizioneParco" :maxLengthFactor="maxRailLength360Scaled" :maxLengthTrue="maxRailLength" :lengthInterval="20" />
              </v-row>
            </v-container>

            <railSpatialVisualization
              v-for="binario in binari"
              :key="binario.id"
              :binario="binario"
              :convogli="filteredConvoys[binario.id]"
              :maxLengthFactor="maxRailLength360Scaled"
              :maxLengthTrue="maxRailLength"
              :lengthInterval="20"
              :selected="selectedRailId == binario.id"
              :utiSearchParam="utiSearchParam ? utiSearchParam.trim() : ''"
              :wagonSearchParam="wagonSearchParam ? wagonSearchParam.trim() : ''"
              :plannedShowing="!realtimeView"
              :features="shipFilterEnabled ? [] : selectedFeatures"
              :yardShowing="yardShowing"
              :convoglioSel="convoglioSel"
              :numBinario="binario.numero"
              :parkPosition="binario.parcoBinari.posizioneParco"
              :filtered-ships="selectedShips"
              :ship-filter-enabled="shipFilterEnabled"
              :ship-colors="shipColors"
              :scaleFactor="scaleFactor"
              :measureEnabled="measureEnabled"
              @mouseMoveOnRail="updateLinePositionOnRail"
              @lineVisible="updateLineVisible"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row align="center">
      <v-col cols="12" class="ma-0 mt-2 pa-0">
        <v-toolbar color="grey lighten-3" elevation="0" dense>
          <legend-footer
            :utiWagonStatesExport="utiWagonStatesExport"
            :utiWagonStatesImport="utiWagonStatesImport"
            :utiFeaturesLegendVoices="utiFeaturesLegendVoices"
            :wagonFeaturesLegendVoices="wagonFeaturesLegendVoices"
          />
          <v-spacer />
          <v-switch v-model="realtimeView" inset hide-details title="Attiva/Disattiva vista REALTIME">
            <template v-slot:label>
              <div class="text-h6 font-weight-light primary--text">REALTIME</div>
            </template>
          </v-switch>

          <v-btn icon @click="zoomOut" title="Zoom Out" class="ml-4">
            <v-icon>mdi-magnify-minus-outline</v-icon>
          </v-btn>
          <v-btn icon @click="zoomIn" title="Zoom In">
            <v-icon>mdi-magnify-plus-outline</v-icon>
          </v-btn>

          <v-btn
            :color="measureEnabled === true ? 'amber darken-2' : 'grey lighten-2'"
            class="ml-8 pa-2 rounded-xl rounded-tr-0 rounded-br-0 text-center"
            height="40"
            elevation="0"
            @click="enableDisableMeasure"
            title="Abilita/disabilita misure"
          >
            <v-icon size="26" :color="measureEnabled === true ? 'white' : 'amber darken-3'">mdi-ruler</v-icon>
          </v-btn>

          <div
          :style="'width: 60px; height: 40px; background-color: ' + (measureEnabled === true ? '#FFF8E1' : '#FAFAFA') + ';'"
            :class="'custom-border d-flex align-center justify-center text-subtitle-1 ' + (measureEnabled === false ? 'grey--text' : 'primary--text font-weight-medium')"
          >
            {{ mouseXOnRail }}
        </div>

          <v-btn icon @click="fetchData" :title="tLabel('renew')" class="ml-4">
            <v-icon large color="secondary">mdi-autorenew</v-icon>
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>

    <wagon-dialog
      :drawer="dialog"
      :carroConvoglio="carroSel"
      :plannedShowing="!realtimeView"
      @close="(dialogOpenValue) => (dialog = dialogOpenValue)"
      :features="selectedFeatures"
    />
  </v-container>
</template>

<script>
import _ from "lodash";
import multiParkManagementMixins from "../../mixins/MultiParkManagementMixins";
import convoyVisualizationMixins from "../../components/rails/mixins/convoyVisualizationMixins";
import railSpatialVisualization from "../../components/rails/RailSpatialVisualization";
import legendFooter from "../../components/rails/LegendFooter";
import wagonDialog from "../../components/rails/WagonDialog";
import convoyDialog from "../../components/rails/convoy/ConvoyDialog";
import LengthMarker from "../../components/rails/LengthMarker.vue";

export default {
  name: "realTimeVisualization",
  components: {
    railSpatialVisualization,
    wagonDialog,
    convoyDialog,
    legendFooter,
    LengthMarker,
  },
  data() {
    return {
      railZoom: 1,
      isFooterVisible: false,
      binari: [],
      listaGru: [],
      convogli: {},
      resConvogli: [],
      railsWagonsMap: {},
      selectedRailId: -1,
      carroSel: null,
      convoglioSel: null,
      tapEvCache: [],
      tapPrevDiff: -1,
      craneMoving: false,
      dialog: false,
      dialogConvoy: false,
      timerRT: null,
      utiSearchParam: "",
      wagonSearchParam: "",
      realtimeView: true,
      yardShowing: false,
      yardShowingPrec: false,
      toggle_exclusive: [],
      wagonFeaturesLegendVoices: {
        lowered: {
          label: "RIBASSATO",
          color: "#BDBDBD",
          special: "bottom-black-line",
        },
        damaged: {
          label: "DANNEGGIATO",
          color: "#BDBDBD",
          special: "bottom-red-line",
        },
      },
      utiFeaturesLegendVoices: {
        featuresMultiple: {
          label: "FEATURES MULTIPLE",
          color: "#FFFFFF",
          icon: "mdi-checkbox-multiple-blank-outline",
        },
        reefer: {
          label: "REEFER",
          color: "#29B6F6",
          icon: "mdi-snowflake",
          iconColor: "#ffffff",
        },
        imo: {
          label: "PERICOLOSO",
          color: "#ffffff",
          icon: "mdi-rhombus",
          iconColor: "#D32F2F",
        },
        tons: {
          label: "> 29 TONS",
          color: "#ffffff",
          icon: "mdi-weight",
          iconColor: "#000000",
        },
        empty: {
          label: "VUOTO",
          color: "#BDBDBD",
          border: "2px",
          borderColor: "#000000",
        },
        highCube: {
          label: "HIGH CUBE",
          color: "#BDBDBD",
          special: "top-line",
        },
        error: {
          label: "ERRORI DATI",
          color: "#BDBDBD",
          border: "2px",
          borderColor: "#D32F2F",
        },
      },
      features: [
        { codice: "REE", label: "Reefer", type: "U" },
        { codice: "IMO", label: "Pericoloso", type: "U" },
        { codice: "TON", label: "> 29tons", type: "U" },
        { codice: "EMP", label: "Vuoto", type: "U" },
        { codice: "HCB", label: "High cube", type: "U" },
        { codice: "RIB", label: "Ribassato", type: "C" },
        { codice: "DAN", label: "Danneggiato", type: "C" },
        { codice: "ERR", label: "Errore dati", type: "C" },
      ],
      scaleFactor: 0.6,
      selectedFeatures: ["IMO", "DAN"],
      selectedVessel: null,
      selectedDynamicBlock: "features",
      showDynamicBlocksArea: false,
      popoverLeft: 0,
      popoverTop: 0,
      shipFilterEnabled: false,
      selectedShips: [],
      availableShips: [],
      shipColors: {},
      lineLeft: 0,
      mouseXOnRail: 0,
      lineVisible: false,
      measureEnabled: false,
      railContainerWidth: 0,
    };
  },
  mixins: [multiParkManagementMixins, convoyVisualizationMixins],
  created() {
    this.$eventBus.$on("wagonSelected", (carro) => {
      this.carroSel = carro;
      this.dialog = true;
    });
    this.$eventBus.$on("wagonUnSelected", () => {
      this.carroSel = null;
      this.dialog = false;
    });
    this.$eventBus.$on("selectingRail", (railId) => (this.selectedRailId = railId));
    this.$eventBus.$on("convoySelected", (idConvoglio) => {
      this.$router.push({ path: `/rails/ConvoyVisualization/${idConvoglio}` });
    });
    this.$eventBus.$on("utiStatusChanged", () => {
      this.$set(this.carroSel, "carroSel");
      this.$set(this.convogli, "convogli");
    });
    this.$eventBus.$on("convoyHighlighted", (idConvoglio) => {
      this.convoglioSel = this._.find(this.resConvogli, (c) => c.id === idConvoglio);
      this.dialogConvoy = true;
    });
    this.$eventBus.$on("convoyDeHighlighted", () => {
      this.dialogConvoy = false;
      this.convoglioSel = null;
    });
  },
  async destroyed() {
    await this.clearDataUpdater();
  },
  async mounted() {
    // this.fitToContainer();
    // window.addEventListener("resize", this.fitToContainer);
    await this.fetchData();
    await this.fetchShipColors();
    this.initComponent();
  },
  // beforeDestroy() {
  //   window.removeEventListener("resize", this.fitToContainer);
  // },
  computed: {
    svgStyle() {
      return {
        zIndex: "100",
        position: "absolute",
        top: 0,
        left: 0,
        width: this.railContainerWidth,
        height: "100%",
        pointerEvents: "none",
      };
    },
    maxRailLength360Scaled() {
      return this.getMaxLengthRail360Scaled();
    },
    maxRailLength() {
      return this.getMaxLengthRail();
    },
    utiWagonStatesExport() {
      return this.$config.rails.utiWagonStates["arrival"];
    },
    utiWagonStatesImport() {
      return this.$config.rails.utiWagonStates["departure"];
    },
    plannedActivationBtnText() {
      return (!this.realtimeView ? "Nascondi" : "Visualizza") + " pianificate/scaricate/da caricare";
    },
    yardActivationBtnText() {
      return (this.yardShowing ? "Nascondi" : "Visualizza") + " aree Yard";
    },
    filteredConvoys() {
      return this.convogli;
    },
    filteredAvailableShipsByPark() {
      // console.log("--- DEBUG filteredAvailableShipsByPark ---");
      // console.log("shipFilterEnabled:", this.shipFilterEnabled);
      // console.log("selectedPark:", this.selectedPark);
      // console.log("resConvogli.length:", this.resConvogli.length);
      // if (this.resConvogli.length > 0) {
      //   console.log("Struttura dell'oggetto binario del primo convoglio (per debug):", this.resConvogli[0].binario);
      // }
      // console.log("availableShips.length (all ships):", this.availableShips.length);

      if (!this.shipFilterEnabled || !this.selectedPark || !this.resConvogli.length) {
        // console.log("Returning all availableShips due to filter conditions.");
        return this.availableShips;
      }

      const convoysInSelectedPark = this.resConvogli.filter((convoy) => {
        const convoyParkCode = convoy.binario ? convoy.binario.codiceParcoBinari : null;
        const selectedParkCode = this.selectedPark.codice;
        const matchesPark = convoyParkCode && selectedParkCode && convoyParkCode.toLowerCase() === selectedParkCode.toLowerCase();
        return matchesPark;
      });
      // console.log("Convoys in selected park:", convoysInSelectedPark.length);
      const carrierOutVoyInPark = new Set();
      convoysInSelectedPark.forEach((convoy) => {
        if (convoy.listCarri) {
          convoy.listCarri.forEach((carro) => {
            if (carro.listUti) {
              carro.listUti.forEach((uti) => {
                if (uti.visitaUti.carrierOutVoy) {
                  carrierOutVoyInPark.add(uti.visitaUti.carrierOutVoy);
                }
              });
            }
          });
        }
      });
      // console.log("Unique carrierOutVoy found in selected park:", Array.from(carrierOutVoyInPark));

      const finalFilteredShips = this.availableShips.filter((ship) => carrierOutVoyInPark.has(ship.carrierOutVoy));
      return finalFilteredShips;
    },
  },
  methods: {
    enableDisableMeasure() {
      this.measureEnabled = !this.measureEnabled;
    },
    updateLineVisible(event) {
      if (this.lineVisible !== event) {
        this.lineVisible = event;
      }
    },
    updateLinePositionOnRail(event) {
      let gap = event.railDivLeft - this.$refs["railParkCntrRef"].getBoundingClientRect().left + document.querySelector("#railParkCntr").scrollLeft;
      this.lineLeft = (event.lineLeft + gap) / this.scaleFactor;
      this.railContainerWidth = (event.width + gap) / this.scaleFactor;
      this.mouseXOnRail = event.mouseXOnRail;
    },
    calc() {
      let ctr = document.querySelector("#railParkCntr");
      console.log("calc ----- ctr", ctr);
      if (!ctr || ctr === null) {
        return;
      }

      const containerWidth = ctr.clientWidth;
      console.log("calc ----- containerWidth ", containerWidth);
      const containerHeight = ctr.clientHeight;
      console.log("calc ----- containerHeight ", containerHeight);

      const contentWidth = ctr.scrollWidth;
      console.log("calc ----- contentWidth ", contentWidth);
      const contentHeight = ctr.scrollHeight;
      console.log("calc ----- contentHeight ", contentHeight);

      const scaleX = containerWidth / contentWidth;
      console.log("calc ----- scaleX ", scaleX);
      const scaleY = containerHeight / contentHeight;
      console.log("calc ----- scaleY ", scaleY);

      console.log("calc ----- scale factor ", Math.min(scaleX, scaleY, 1));

      this.scaleFactor = Math.min(Math.floor(scaleX * 100) / 100, Math.floor(scaleY * 100) / 100, 1);
    },
    handleWheel(e) {
      if (e.ctrlKey) {
        e.preventDefault();
        const delta = Math.sign(e.deltaY);
        if (delta > 0) {
          this.zoomOut();
        } else {
          this.zoomIn();
        }
      }
    },
    async fetchData() {
      if (!this.parkName) {
        return;
      }

      await this.loadRailwayData();
      await this.loadRealTimeData();
    },
    async clearDataUpdater() {
      try {
        if (this.timerRT) {
          clearInterval(this.timerRT);
        }
        await this.$wsHubUnRegister("railVisualizationRT");
      } catch (e) {
        console.log(e);
      }
    },
    async renewData() {
      try {
        await this.clearDataUpdater();
        await this.fetchData();
      } catch (e) {
        console.log(e);
      }
    },
    initComponent() {
      const railParkSubCntr = document.querySelector("#railPark");
      const railParkCntr = document.querySelector("#railParkCntr");
      let isDown = false;
      let startX, startY, scrollLeft, scrollTop;

      this.$utilities.dom.addHandler(railParkCntr, "wheel", (e) => {
        if (e.ctrlKey) {
          e.preventDefault();
          e.stopPropagation();

          const delta = Math.sign(e.deltaY);
          if (delta > 0) {
            this.zoomOut();
          } else {
            this.zoomIn();
          }
        }
      });

      this.$utilities.dom.addHandler(railParkSubCntr, ["wheel"], (e) => {
        e.stopPropagation();
        e.preventDefault();
        if (e.ctrlKey) {
          if (this.$utilities.dom.detectMouseWheelDirection(e) === "up") {
            this.railZoom += this.railZoom < 3 ? 0.1 : 0;
          } else {
            this.railZoom -= this.railZoom > 1 ? 0.1 : 0;
          }
          railParkSubCntr.setAttribute(
            "style",
            `zoom:${this.railZoom};transform: scale(${this.railZoom});transform-origin: 0 0;-webkit-transform-origin: 0 0;-moz-transform:Scale(${this.railZoom});-moz-transform-origin:0 0`
          );
        }
      });

      this.$utilities.dom.addHandler(railParkSubCntr, ["pointerdown"], (e) => {
        this.tapEvCache.push(e);
      });

      this.$utilities.dom.addHandler(railParkSubCntr, ["pointerup"], (e) => {
        for (var i = 0; i < this.tapEvCache.length; i++) {
          if (this.tapEvCache[i].pointerId == e.pointerId) {
            this.tapEvCache.splice(i, 1);
            break;
          }
        }
      });

      this.$utilities.dom.addHandler(railParkSubCntr, ["pointermove"], (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (this.tapEvCache.length == 2) {
          let curDiff = Math.abs(this.tapEvCache[0].clientX - this.tapEvCache[1].clientX);
          if (this.tapPrevDiff > 0) {
            if (curDiff > this.tapPrevDiff) {
              this.railZoom += this.railZoom < 3 ? 0.1 : 0;
            }
            if (curDiff < this.tapPrevDiff) {
              this.railZoom -= this.railZoom > 1 ? 0.1 : 0;
            }
            railParkSubCntr.setAttribute("style", `zoom:${this.railZoom};-moz-transform:Scale(${this.railZoom});-moz-transform-origin:0 0`);
          }
          this.tapPrevDiff = curDiff;
        } else {
          if (!isDown || this.craneMoving) return;

          const x = e.pageX - railParkCntr.offsetLeft;
          const walk = x - startX;
          railParkCntr.scrollLeft = scrollLeft - walk;

          const y = e.pageY - railParkCntr.offsetTop;
          const walkY = y - startY;
          railParkCntr.scrollTop = scrollTop - walkY;
        }
      });

      this.$utilities.dom.addHandler(railParkCntr, ["pointerdown"], (e) => {
        isDown = true;
        startX = e.pageX - railParkCntr.offsetLeft;
        startY = e.pageY - railParkCntr.offsetTop;
        scrollLeft = railParkCntr.scrollLeft;
        scrollTop = railParkCntr.scrollTop;
      });

      this.$utilities.dom.addHandler(railParkCntr, ["pointerleave"], () => {
        isDown = false;
      });

      this.$utilities.dom.addHandler(railParkCntr, ["pointerup"], () => {
        isDown = false;
      });
    },
    getMaxLengthRail360Scaled() {
      const maxLengthRail = this._.maxBy(this.binari, (b) => {
        return b.lunghezza;
      });
      return maxLengthRail && maxLengthRail.lunghezza ? Math.min(maxLengthRail.lunghezza, 360) : 0;
    },
    getMaxLengthRail() {
      const maxLengthRail = this._.maxBy(this.binari, (b) => {
        return b.lunghezza;
      });
      return maxLengthRail && maxLengthRail.lunghezza ? maxLengthRail.lunghezza : 0;
    },
    async loadRailwayData() {
      try {
        if (!this.parkName) return;
        this.binari = (await this.$api.railData.getRailwayData(this.parkName)).reverse();
      } catch (e) {
        console.log(e);
      }
    },
    async loadCraneData() {
      try {
        this.listaGru = await this.$api.railData.getCraneData(this.parkName);
      } catch (e) {
        console.log(e);
      }
    },
    async loadRealTimeData() {
      console.time("railVisualizationRT_Time1");
      try {
        if (!this.$wsHubIsGroupRegistered("railVisualizationRT")) {
          await this.$wsHubRegister("railVisualizationRT", { parco: this.parkName }, (resConvogli) => this.setRealTimeData(resConvogli));
        }
        this.$wsHubOnDataChangedEvent("railVisualizationRT");
      } catch (e) {
        console.warn("railVisualizationRT error", e);
        let resConvogli = await this.$api.railData.getRailwayDataRT(this.parkName);
        this.setRealTimeData(resConvogli);

        if (this.timerRT) {
          clearInterval(this.timerRT);
        }
        this.timerRT = setInterval(async () => {
          try {
            console.log("in timeOut getRailwayDataRT");
            resConvogli = await this.$api.railData.getRailwayDataRT(this.parkName);
            this.setRealTimeData(resConvogli);
          } catch (e) {
            console.log(e);
          }
        }, 60000);
      }
      console.timeEnd("railVisualizationRT_Time1");
    },
    setRealTimeData(resConvogli) {
      this.resConvogli = resConvogli;
      this.resConvogli.forEach((c) => (this.wagonTotalCount += c.listCarri ? c.listCarri.length : 0));
      this.convogli = this._.transform(
        resConvogli,
        (result, convoglio) => {
          result[convoglio.binarioId] = _.filter(resConvogli, (c) => c.binarioId == convoglio.binarioId);
          return result;
        },
        {}
      );
    },
    onClickPlannedShow() {
      this.realtimeView = !this.realtimeView;
    },
    onClickYardShow() {
      this.yardShowing = !this.yardShowing;
    },
    selectDeselectAllFeatures() {
      if (this.selectedFeatures.length === this.features.length) {
        this.selectedFeatures = new Array();
      } else {
        this.selectedFeatures = this.features.map((f) => f.codice);
      }
    },
    selectDeselectAllShips() {
      if (this.selectedShips.length === this.filteredAvailableShipsByPark.length) {
        this.selectedShips = new Array();
      } else {
        this.selectedShips = this.filteredAvailableShipsByPark.map((s) => s.carrierOutVoy);
      }
    },
    // fitToContainer() {
    //   const container = document.getElementById("railParkCntr");
    //   if (!container) return;

    //   const containerWidth = container.clientWidth;
    //   const containerHeight = container.clientHeight;
    //   const contentWidth = content.scrollWidth;
    //   const contentHeight = content.scrollHeight;

    //   const scaleX = containerWidth / contentWidth;
    //   const scaleY = containerHeight / contentHeight;

    //   this.scaleFactor = Math.min(scaleX, scaleY, 1); // Non ingrandire oltre 1
    // },
    zoomIn() {
      this.scaleFactor = Math.min(this.scaleFactor + 0.1, 2); // max 200%

      if (this.selectedPark.posizioneParco === "DX") {
        this.$nextTick(() => {
          let ctr = document.querySelector("#railParkCntr");
          if (!ctr || ctr === null) {
            return;
          }
          ctr.scrollLeft = ctr.scrollWidth;
        });
      }
    },
    zoomOut() {
      this.scaleFactor = Math.max(this.scaleFactor - 0.1, 0.3); // min 30%

      if (this.selectedPark.posizioneParco === "DX") {
        this.$nextTick(() => {
          let ctr = document.querySelector("#railParkCntr");
          if (!ctr || ctr === null) {
            return;
          }
          ctr.scrollLeft = ctr.scrollWidth;
        });
      }
    },
    selectDynamicBlock(blockName) {
      this.selectedDynamicBlock = blockName;
      this.showDynamicBlocksArea = false; // Chiudi l'area di selezione dopo la scelta
    },
    async fetchShipColors() {
      try {
        const response = await this.$api.railData.getColoreNavi();
        // console.log("API Response getColoreNavi:", response.data);
        const shipData = response.data;
        this.availableShips = shipData.map((ship) => ({
          id: ship.id,
          colore: ship.colore,
          callId: ship.callId,
          carrierOutVoy: ship.carrierOutVoy,
          updatedAt: ship.updatedAt,
          label: `${ship.carrierOutVoy} (${ship.callId})`,
          color: ship.colore,
        }));
        this.shipColors = _.keyBy(shipData, "carrierOutVoy");
      } catch (error) {
        console.error("Errore nel recupero dei colori navi:", error);
      }
    },
    toggleShipFilter(enabled) {
      if (enabled && this.availableShips.length === 0) {
        this.fetchShipColors();
      }

      if (enabled) {
        this.yardShowingPrec = this.yardShowing;
        this.yardShowing = false;
      } else {
        this.yardShowing = this.yardShowingPrec;
      }
    },

    getShipColor(callId) {
      return this.shipColors[callId]?.colore || "#CCCCCC";
    },
  },
  watch: {
    wagonSearchParam: async function (newValue) {
      const targa = newValue.trim();
      try {
        const convogli = this._.filter(this.resConvogli, (c) => {
          return this._.find(c.listCarri, (cc) => {
            const licensePlate = this.getCarroLicensePlate(cc);
            return targa && ((targa.length >= 3 && licensePlate.includes(targa.toLowerCase())) || licensePlate === targa.toLowerCase());
          });
        });

        if (!convogli.length && targa.length > 2) {
          const parcoRes = await this.$api.trainData.getParcoPerRicercaCarro(targa);
          if (!parcoRes || !parcoRes.parco) return;
          this.selectedPark = this._.find(this.parks, (p) => p.codice.toLowerCase() === parcoRes.parco.toLowerCase());
          this.showSuccess(`La ricerca per carro ha trovato corrispondenza sul parco ${this.selectedPark.codice}`);
        }
      } catch (e) {
        console.log(e);
      }
    },
    parkName: async function () {
      await this.$wsHubUnRegister("railVisualizationRT");
      await this.fetchData();
    },
    convogli: {
      handler: function (newConvogliVal) {
        this.railsWagonsMap = this._.transform(
          newConvogliVal,
          (result, convogli, idBinario) => {
            convogli.forEach((convoglio) => {
              if (convoglio.listCarri && convoglio.listCarri.length > 0) {
                result[idBinario] = convoglio.listCarri;
              }
            });
            return result;
          },
          {}
        );
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.custom-border {
  border: 1px solid #BDBDBD; /* width style color */
}

.rail-row {
  z-index: 1;
  height: 40px;
  position: relative;
}

.rail-park-cntr {
  /* width: 100%; */
  height: calc(100vh - 216px);
  border: 1px solid #ccc;
  overflow: auto;
}

.overlay-popover-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 99;
  display: block;
}

.overlay-popover-container >>> .v-overlay__content {
  pointer-events: auto;
  position: absolute !important;
  transform: none !important;
}

.custom-popover-card {
  background-color: transparent !important;
  box-shadow: none !important;
}

.popover-content-row {
  background-color: #f0f0f0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.popover-content-row:hover {
  background-color: #f0f0f0;
  transform: none;
}

.no-radius-left {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.no-radius-right {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

/* Stili per i testi neri nei v-text-field e v-select */
.v-text-field >>> .v-input__control .v-input__slot fieldset,
.v-select >>> .v-input__control .v-input__slot fieldset {
  border-color: rgba(0, 0, 0, 0.42) !important;
}

.v-text-field >>> input,
.v-select >>> .v-select__selection,
.v-select >>> .v-label {
  color: black !important;
}

.popover-content-row .v-text-field >>> input,
.popover-content-row .v-text-field >>> .v-label,
.popover-content-row .v-text-field >>> .v-icon,
.popover-content-row .v-select >>> .v-select__selection,
.popover-content-row .v-select >>> .v-label,
.popover-content-row .v-select >>> .v-icon {
  color: black !important;
}

/*
 * Seleziona lo switch con la nostra classe custom (.uniform-color-switch)
 * SOLO quando NON è attivo (:not(.v-input--is-label-active)).
 * Poi, con ::v-deep, entriamo nel suo CSS interno per modificare la traccia.
*/
.color-switch:not(.v-input--is-label-active) ::v-deep .v-input--switch__track {
  /* Imposta lo stesso colore della prop 'color' */
  background-color: #f9a825 !important;
  border-color: #f9a825 !important;

  /*
   * OPZIONALE ma consigliato:
   * Riduci l'opacità per dare un feedback visivo
   * che lo switch è spento, pur mantenendo lo stesso colore.
  */
  opacity: 0.5;
}

.color-switch:not(.v-input--is-label-active) ::v-deep .v-input--switch__thumb {
  background-color: #f57f17 !important;
}
</style>
